<template>
    <v-card class="elevation-12">
      <v-toolbar
        color="primary"
        dark
        flat
        v-if="showToolbar"
      >
        <v-toolbar-title>{{$t('Dialogs.TopupBalance.title')}}</v-toolbar-title>
      </v-toolbar>
      <v-container>
        <!-- -->
        <v-alert
          v-if="isSuccessfullyCompleted && successMessage"
          type="success"
          dense
          border="left"
        >
          {{successMessage}}
        </v-alert>
        <!-- -->
        <v-alert
          v-if="errorMessage"
          type="error"
          dense
          border="left"
          dismissible
        >
          {{errorMessage}}
        </v-alert>
        <!-- -->
        <ajax
          v-model="publicKey"
          method="get"
          :url="getStripePublicKeyUrl()"
          :query="publicKeyQueryParams"
          :transform="$api.getData"
          :catch="ajaxPublicKeyOnErrorHandler"
          ref="ajaxPublicKey"
          v-slot="{pending:publicKeyPending, success: publicKeySuccess, response: publicKeyResponse, error: publicKeyError}"
        >
          <!-- -->
          <ajax
            v-model="minMaxAmounts"
            method="get"
            :url="getStripeMinMaxAmountsUrl()"
            :query="minMaxAmountsQueryParams"
            :transform="$api.getData"
            :catch="ajaxMinMaxAmountsOnErrorHandler"
            ref="ajaxMinMaxAmounts"
            v-slot="{pending:minMaxAmountsPending, success: minMaxAmountsSuccess, response: minMaxAmountsResponse, error: minMaxAmountsError}"
          >
            <!-- Форму и прочее имеет смысл показывать, если загрузился ключ и суммы -->
            <v-container>
              <!-- Ожидаем, пока загрузятся ключ и суммы -->
              <v-container v-if="publicKeyPending || minMaxAmountsPending">
                <progress-linear :width="12"></progress-linear>
              </v-container>

              <!-- Если что-то закончилось ошибкой, то следует показать эту ошибку в errorMessage, а сам контент не показывать/скрыть -->
              <v-container v-if="publicKeyError || minMaxAmountsError"/>

              <!-- Если все загрузилось успешно, то отображаем формы и пр. -->
              <v-container
                v-else-if="publicKeySuccess && publicKeyResponse && minMaxAmountsSuccess && minMaxAmountsResponse">
                <!-- До полного завершения платежа отображаем форму и дальнейший ход выполнения -->
                <v-container v-if="!isSuccessfullyCompleted">
                  <!-- Форма, до нажатия на submit-кнопку + и после, т.к. для работы Stripe важно присутствие элемента card в DOM  -->
                  <v-container v-if="true">
                    <v-form id="topup-balance-form" @submit="okOnClick" v-model="isFormValid">
                      <v-text-field type="email"
                                    name="email"
                                    :label="$t('Dialogs.TopupBalance.emailLabel')"
                                    v-model="email"
                                    :readonly="isInDialog"
                                    :rules="[emailInputRules.dot]"
                      ></v-text-field>
                      <v-text-field name="phone"
                                    :label="$t('Dialogs.TopupBalance.phoneLabel')"
                                    v-model="item.inum"
                                    :readonly="isInDialog"
                                    :rules="[inumInputRules.startsWith, inumInputRules.length]"
                      ></v-text-field>
                      <v-text-field v-model="decimalAmount"
                                    name="decimalAmount"
                                    :label="$t('Dialogs.TopupBalance.amountLabel')"
                                    :rules="[amountInputRules.min, amountInputRules.max, amountInputRules.isValidSum]"
                                    @input="sumOnInput"
                                    placeholder=""
                      ></v-text-field>
                      <div id="card-element" v-inserted-event="initStripe">
                        <!-- A Stripe Element will be inserted here. -->
                      </div>
                      <!-- Used to display form errors. -->
                      <div id="card-errors" class="error"></div>
                    </v-form>

                    <!-- После нажатия на submit-кнопку -->
                    <v-container v-if="isSubmitted">
                      <ajax
                        v-model="check"
                        method="post"
                        :url="getStripeCheckUrl()"
                        :query="checkQueryParams"
                        :catch="ajaxCheckOnErrorHandler"
                        v-slot="/* eslint-disable-next-line vue/no-unused-vars */
                  {pending:checkPending, success:checkSuccess, response:checkResponse, error:checkError}">
                        <v-container>
                          <progress-linear :width="12" v-if="checkPending"></progress-linear>
                          <v-container v-else-if="checkSuccess && checkResponse">
                            <div v-if="checkResponse.data.data.stripe">
                              <div v-inserted-event="confirmCardPayment"></div>
                            </div>
                          </v-container>
                        </v-container>
                      </ajax><!-- ajax-check -->
                    </v-container>
                    <!-- -->
                  </v-container>
                  <!-- -->
                </v-container><!-- /!isSuccessfullyCompleted -->
                <v-container v-else-if="isSuccessfullyCompleted">
                  <!-- Тут, вероятно, нечего показывать, скорее success-alert'а будет достаточно -->
                  <!-- А вот web-hook отправить можно/нужно -->
                  <ajax
                    method="post"
                    :url="getStripeWebHookUrl()"
                    :query="webHookQueryParams"
                  ></ajax>
                </v-container><!-- /isSuccessfullyCompleted -->
                <!-- -->
              </v-container>
              <!-- -->
            </v-container>
          </ajax><!-- ajax-minMaxAmounts -->
        </ajax><!-- ajax-publicKey -->
      </v-container>
      <v-card-actions>
        <v-img src="../assets/logo/payment-methods/Dark Color/1.png" max-width="60" contain class="pr-1"></v-img>
        <v-img src="../assets/logo/payment-methods/Dark Color/2.png" max-width="60" contain class="pr-1"></v-img>
        <v-spacer></v-spacer>
        <v-btn
          v-if="showCancelButton"
          text
          color="primary"
          @click="cancelOnClick"
          v-html="$t('Dialogs.TopupBalance.cancelButtonCaption')"
        >
        </v-btn>
        <v-btn
          v-if="showOkButton"
          color="primary"
          type="submit"
          form="add-number-form"
          :disabled="!canSubmit"
          @click.prevent="okOnClick"
          v-html="$t('Dialogs.TopupBalance.payNowButtonCaption')"
        >
        </v-btn>
        <v-btn
          v-if="showFinishButton"
          color="primary"
          type="submit"
          form="add-number-form"
          :disabled="false"
          @click.prevent="finishOnClick"
          v-html="$t('Dialogs.TopupBalance.okButtonCaption')"
        >
        </v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
/* eslint-disable indent */

import Ajax from './Ajax'
import ProgressLinear from './ProgressLinear'
import stripeMixin from '../mixins/stripe'

export default {
  name: 'TopupBalance',
  props: {
    showToolbar: {
      type: Boolean,
      default: false
    },
    /**
     * Объкт сим-карты
     */
    item: {
      type: Object,
      default: function () {
        return {
          inum: ''
        }
      }
    },
    email: {
      type: String,
      default: ''
    },
    isInDialog: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  },
  components: {
    ProgressLinear,
    Ajax
  },
  mixins: [stripeMixin],
  data: function () {
    return {
      /**
       * Модель запроса публичного ключа
       */
      publicKey: null,
      /**
       * Модель запроса допустимых мин./макс. сумм
       */
      minMaxAmounts: {
        amounts: {
          min: null,
          max: null
        }
      },
      /**
       * Модель запроса возможности проведения платежа check
       */
      check: null,

      /**
       * Модель формы
       */
      isFormValid: false,
      /**
       */
      successMessage: '',
      /**
       * Сообщения об ошибках
       */
      errorMessage: '',
      /**
       * Сумма платежа, введенная пользователем
       */
      decimalAmount: '',
      /**
       * Stripe-клиент
       */
      stripe: null,
      /**
       * Stripe UI-элемент карты
       */
      card: null,
      /**
       * Карта введена и прошла проверку на уровне Stripe UI
       */
      stripeCardComplete: false,
      /**
       */
      stripePaymentIntentId: null,
      /**
       * Нажата кнопка ОК
       */
      isSubmitted: false,
      /**
       * Уникальный код транзакции - должен быть один в пределах одного открытого диалога
       */
      uniqueCode: null,
      /**
       * Полное и успешное заверщение платежа
       */
      isSuccessfullyCompleted: false
    }
  },
  computed: {
    publicKeyQueryParams: function () {
      return {}
    },
    minMaxAmountsQueryParams: function () {
      return {}
    },
    checkQueryParams: function () {
      return {
        inum: this.item.inum,
        email: this.email,
        amount: (this.decimalAmount * 100).toFixed(0),
        ts: this.uniqueCode
      }
    },
    webHookQueryParams: function () {
      return {
        id: this.stripePaymentIntentId
      }
    },
    showFinishButton: function () {
      return this.isSuccessfullyCompleted
    },
    showOkButton: function () {
      return !this.isSubmitted
    },
    showCancelButton: function () {
      /**
       * Нет смысла показывать кнопку без диалога - она все равно ничего не деалет
       */
      return !this.isSubmitted && this.isInDialog
    },
    minAmountInHighestCurrencyUnitAsFloat: function () {
      /**
       * @link https://stripe.com/docs/currencies#zero-decimal
       */
      return this.amountAsFloat(this.minMaxAmounts.amounts.min) / 100
    },
    maxAmountInHighestCurrencyUnitAsFloat: function () {
      /**
       * @link https://stripe.com/docs/currencies#zero-decimal
       */
      return this.amountAsFloat(this.minMaxAmounts.amounts.max) / 100
    },
    amountInputRules: function () {
      return {
        required: value => !!value || 'Required',
        min: value => (parseFloat(value) >= this.minAmountInHighestCurrencyUnitAsFloat) || this.$t('Dialogs.TopupBalance.messages.MinAmount', { amount: this.$options.filters.money(this.minAmountInHighestCurrencyUnitAsFloat) }),
        max: value => (parseFloat(value) <= this.maxAmountInHighestCurrencyUnitAsFloat) || this.$t('Dialogs.TopupBalance.messages.MaxAmount', { amount: this.$options.filters.money(this.maxAmountInHighestCurrencyUnitAsFloat) }),
        isValidSum: value => ((/^\d+(\.\d{1,2})?$/).test(value)) || this.$t('Dialogs.TopupBalance.messages.InvalidAmount')
      }
    },
    inumInputRules: function () {
      return {
        required: value => !!value || this.$t('Dialogs.TopupBalance.messages.Required'),
        length: value => (value.toString().length === 11) || this.$t('Dialogs.TopupBalance.messages.InvalidMSISDN'),
        startsWith: value => (value.toString().indexOf('372') === 0) || this.$t('Dialogs.TopupBalance.messages.InvalidMSISDN')
      }
    },
    emailInputRules: function () {
      return {
        required: value => !!value || this.$t('Dialogs.TopupBalance.messages.Required'),
        dot: value => (value.toString().indexOf('@') !== -1) || this.$t('Dialogs.TopupBalance.messages.InvalidEmail')
      }
    },
    canSubmit: function () {
      return this.isFormValid && this.stripeCardComplete && !this.isSubmitted && !this.isSuccessfullyCompleted
    }
  },
  methods: {
    refreshUniqueCode: function () {
      this.uniqueCode = new Date().getTime()
    },
    showInternalError: function () {
      this.errorMessage = this.$t('Dialogs.TopupBalance.messages.InternalError')
    },
    ajaxPublicKeyOnErrorHandler: function (error) {
      /**
       * Не удалось получить инициализационные параметры формы, критически важные для проведения платежа, продолжение бессмысленно.
       * Сбрасывать какие-либо значения тоже бессмысленно, т.к. они либо еще не появились, либо еще не успели примениться.
       */
      this.showInternalError()

      return Promise.reject(error)
    },
    ajaxMinMaxAmountsOnErrorHandler: function (error) {
      /**
       * Не удалось получить инициализационные параметры формы, критически важные для проведения платежа, продолжение бессмысленно.
       * Сбрасывать какие-либо значения тоже бессмысленно, т.к. они либо еще не появились, либо еще не успели примениться.
       */
      this.showInternalError()

      return Promise.reject(error)
    },
    ajaxCheckOnErrorHandler: function (error) {
      /**
       * Отображаем ошибку
       */
      this.errorMessage = error.response.data.message
      /**
       * Ошибка на этапе проверки может быть иметь различную природу - как недопустиые параметры,
       * так и ошибка сохранения БД или создания PaymentIntent в Stripe API - необходимо сбрасывать то, что введено
       * пользователем, а так же возникшие в итоге статусы...
       */

      /**
       * Обновляем уникальный псевдоидентификатор платежа, т.к. запись в БД уже вполне могла возникнуть.
       * При этом, даже в случае timeout дублирование платежа невозможно, т.к. пользователь не получил PaymentIntent,
       * а, следовательно, не мог его подтвердить...
       */
      // this.refreshUniqueCode()
      /**
       * Скрываем контейнер с ajax-запросами на оплату и, по сути, включаем кнопки...
       */
      this.isSubmitted = false

      return Promise.reject(error)
    },
    amountAsFloat: function (value) {
      return parseFloat(value)
    },
    hide: function () {
      this.$emit('hideDialog', true)
    },
    okOnClick: function () {
      if (!this.canSubmit) {
        return false
      }

      this.refreshUniqueCode()
      this.isSubmitted = true
      this.errorMessage = ''
      this.successMessage = ''
    },
    cancelOnClick: function () {
      if (!this.isSubmitted) {
        this.hide()
        this.$emit('resolveDialog', false)
      }
    },
    finishOnClick: function () {
      this.hide()
      this.$emit('resolveDialog', true)
    },
    outsideOnClick: function () {
      this.cancelOnClick()
    },
    sumOnInput: function (value) {
      this.$nextTick(() => {
        this.decimalAmount = value.toString().replace(/[^.0-9]/g, '')
      })
    },
    createStripeClient: function () {
      const publicKey = (this.publicKey.keys.public || '').toString()
      // Stripe public key did not received
      if (!publicKey || !publicKey.length) {
        return
      }

      // Already created
      if (this.stripe) {
        return
      }

      try {
        // Create an instance of the Stripe object
        // by providing your publishable API key as the first parameter.
        this.stripe = window.Stripe(publicKey, { locale: this.$store.state.locale })
      } catch (e) {
        console.log(e)
      }
    },
    createStripeCardElement: function () {
      const self = this

      // Already created
      if (this.card) {
        return
      }

      if (!this.stripe) {
        return
      }

      // Stripe Elements is a set of prebuilt UI components,
      // like inputs and buttons, for building your checkout flow.
      // It’s available as a feature of Stripe.js.
      //
      // Create an instance of Elements.
      const elements = this.stripe.elements()

      // See https://stripe.com/docs/stripe-js
      //
      // Custom styling can be passed to options when creating an Element.
      // (Note that this demo uses a wider set of styles than the guide below.)
      const style = {
        base: {
          color: 'rgba(0, 0, 0, 0.87)',
          fontFamily: '"fs_elliot_pro", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          lineHeight: 1.5,
          fontSize: '16px',
          '::placeholder': {
            color: 'rgba(0, 0, 0, 0.6)'
          }
        },
        invalid: {
          color: '#ff5252',
          iconColor: '#ff5252'
        }
      }

      try {
        // The Card Element lets you collect card information all within one Element.
        // It includes a dynamically-updating card brand icon as well as inputs for number, expiry, CVC, and postal code.
        //
        // Create an instance of the card Element.
        this.card = elements.create('card', { style: style })

        // Add an instance of the card Element into the `card-element` <div>.
        this.card.mount('#card-element')

        // Handle real-time validation errors from the card Element.
        this.card.on('change', function (event) {
          // const displayError = document.getElementById('card-errors')

          // displayError.textContent = ''
          self.errorMessage = ''
          self.stripeCardComplete = false

          if (event.complete) {
            self.stripeCardComplete = true
          } else if (event.error) {
            // displayError.textContent = event.error.message
            self.errorMessage = event.error.message
          } else {
            //
          }
        })
      } catch (e) {
        // console.log(e)
      }
    },
    initStripe: function () {
      const stripePublicKey = (this.publicKey.keys.public || '').toString()

      if (!stripePublicKey || !stripePublicKey.length) {
        return
      }

      this.createStripeClient()

      if (!this.stripe) {
        return
      }

      this.createStripeCardElement()
    },
    confirmCardPayment: function () {
      const self = this

      if (!this.stripe) {
        return
      }

      this.stripe.confirmCardPayment(
        this.check.data.data.stripe,
        {
          payment_method: {
            card: this.card
          }
        }
      ).then(function (result) {
        // console.log(result)

        if (result.error) {
          // Display error.message in your UI.
          self.errorMessage = result.error.message
          // self.refreshUniqueCode()
          self.isSubmitted = false
          /**
           * Не уверен, что пригодится, но пусть будет
           */
          return Promise.reject(result.error)
        } else {
          // The payment has succeeded
          // Display a success message
          // console.log('The payment has succeeded', result.paymentIntent.id)

          /**
           * Т.к. деньги списаны, а значит мы обязаны их зачислить, то для пользователя
           * всё закончилось, показываем сообщение об успехе
           */
          self.stripePaymentIntentId = result.paymentIntent.id
          self.successMessage = self.$t('Dialogs.TopupBalance.messages.Success', { id: result.paymentIntent.id })
          self.isSuccessfullyCompleted = true

          /**
           * Не уверен, что пригодится, но пусть будет
           */
          return Promise.resolve(result)
        }
      })
    }
  },
  watch: {
    isSubmitted: function (n) {
      this.$emit('updatePersistence', n)
    }
  }
}
</script>

<style type="text/css" scoped>
  >>> .v-dialog--custom {
    width: 90%;
  }

  /* Desktop */
  @media screen and (min-width: 768px) {
    >>> .v-dialog--custom {
      width: 50%;
    }
  }

  #card-element {
    margin-top: 28px;
    border-color: rgba(0, 0, 0, 0.42);
    border-style: solid;
    border-width: 0 0 thin 0;
    padding-bottom: 4px;
  }

</style>
